export default [
  {
    text: '#',
    value: 'id',
    width: '10%',
  },
  {
    text: 'nombre',
    value: 'name',
    width: '25%',
  },
  {
    text: 'producto',
    value: 'wh_product_name',
    align: 'right',
    width: '25%',
  },
  {
    text: 'precio venta',
    value: 'sale_price',
    align: 'right',
    format: 'currency',
    width: '10%',
  },
  {
    text: 'descuento',
    value: 'discount_percentage',
    align: 'right',
    format: 'number',
    input: {
      prefix: '%',
      reverse: true,
      type: 'float-field',
      trigger: discount_percentage_trigger,
    },
    width: '10%',
  },
  {
    text: 'precio oferta',
    value: 'offer_price',
    align: 'right',
    format: 'currency',
    input: {
      type: 'currency-field',
      reverse: true,
      trigger: offer_price_trigger,
    },
    width: '10%',
  },
]

/**
 * 
 */
function discount_percentage_trigger(ctx, props) {
  props.item.discount = props.item.discount_percentage / 100
  props.item.offer_price = Math.round(props.item.sale_price * ( 1 - props.item.discount ))
}

/**
 * 
 */
function offer_price_trigger(ctx, props) {
  props.item.discount = 1 - (props.item.offer_price / props.item.sale_price)
  props.item.discount_percentage = Math.round(props.item.discount * 100)
}